<script setup lang="ts">
import { onMounted } from 'vue';
import { useMapStore } from '@/stores/map';
import { useAssetsStore } from '@/stores/assets';
import EditorLayout from '@/components/EditorLayout.vue';

const mapStore = useMapStore();
const assetsStore = useAssetsStore();

onMounted(async () => {
    // Load assets
    await assetsStore.loadAtlas();

    // Create a default empty map if no map is loaded
    if (!mapStore.hasMap) {
        await mapStore.newMap(100, 100, 0);
    }
});
</script>

<template>
    <EditorLayout />
</template>

<style>
:root {
    /* Matching sprite-editor color scheme */
    --bg-primary: #0d0d14;
    --bg-secondary: #15151f;
    --bg-tertiary: #252536;
    --bg-panel: #1a1a27;
    --bg-hover: #252536;
    --bg-active: #2d2d42;
    --border-color: #2a2a3d;
    --text-primary: #e4e4eb;
    --text-secondary: #9191a8;
    --text-dim: #5c5c72;
    --accent-color: #6366f1;
    --accent-hover: #818cf8;
    --success-color: #22c55e;
    --warning-color: #f59e0b;
    --error-color: #ef4444;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    background-color: var(--bg-primary);
    color: var(--text-primary);
}

button {
    font-family: inherit;
    cursor: pointer;
}

input, select {
    font-family: inherit;
}

::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-track {
    background: var(--bg-secondary);
}

::-webkit-scrollbar-thumb {
    background: var(--border-color);
    border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
    background: var(--bg-hover);
}
</style>
